import HeetsCollection from './HeetsCollection';
export default HeetsCollection;
